import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface ProductCellProps {
  productId: string;
}

export function ProductCell({ productId }: ProductCellProps): ReactElement {
  const { t } = useTranslation();
  return <span>{t(`products.${productId}.label`)}</span>;
}
